import { observer } from 'mobx-react';
import * as React from 'react';
import { FormField } from '../../Types';

interface Props {
  field: FormField;
  optional?: boolean;
}

const Label: React.FC<Props> = ({ field, optional }) =>
  field.label
    .map((label) => (
      <p className="mb-2 text-sm font-semibold text-gray-800">
        <label htmlFor={field.name}>{optional ? `${label} (optional)` : label}</label>
      </p>
    ))
    .getOrElse(() => <></>);

export default observer(Label);
